<template>
  <div class="doc">
    <br />
    <br />
    <p class="title">{{ title }}</p>
    <p class="s-title">Last Updated: 14 November, 2025</p>
    <p class="text">Please read carefully before using the Platform.</p>
    <p class="text">
      <span class="bold">Welcome to</span> OPay Microfinance Bank Limited!
    </p>
    <p class="text">
      OPay Microfinance Bank Limited (<span class="bold"
        >“we”, “us” or “OPay MFB”</span
      >), offers various services (“<span class="bold">the Services</span>”)
      through its platform (“the Platform”) which enable you, either as an
      individual or as an Agent as the case may be, to qualify to borrow small
      amounts over short periods of time (each a “<span class="bold">Loan</span
      >”), transfer and receive funds to and from bank accounts and mobile money
      accounts, other services from third party merchants using your mobile
      money account wallet, as well as provide a host of other services. The
      Platform is operated subject to these Terms of Service
      <span class="bold">(“Terms”)</span>
    </p>
    <br />
    <p class="text">
      <span class="bold">1. This is a Contract.</span>These Terms constitute a
      contract. You may not use the Platform if you do not accept these Terms.
      By using any part of the Platform, you accept these Terms. If you are
      under eighteen (18) years of age, you may not use the Platform.
    </p>
    <p class="text">
      <span class="bold">2. You must accept our privacy policy.</span> To
      provide you with the Services, you must authorize the provision of certain
      personal information to us as described in our privacy policy. Our privacy
      policy governing the Services is attached to and incorporated into these
      Terms (“Privacy Policy”). By accepting these Terms and using the Services,
      you consent to and authorize the collection and use of personal
      information in accordance with the Privacy Policy.
    </p>
    <p class="text">
      <span class="bold">3. You must be truthful.</span>You agree to provide
      true, accurate and complete information about yourself as prompted
      (“Account Data”) and you confirm that you have full authority to provide
      the Account Data including in particular the information relating to the
      person you have provided as your relationship contact. You agree to
      indemnify and keep us indemnified in full against all demands or claims
      that may be brought against us with respect to any information related to
      third parties provided by you to us during your use of the Platform
      including any information related to your relationship contact. You also
      agree to update the Account Data to keep it current.
    </p>
    <p class="text">
      <span class="bold">4. You authorize us to verify your information.</span
      >You hereby authorize us to conduct information verification checks on you
      should we deem it necessary. You further duly authorize us to forward your
      Account Data and personal information to verification suppliers,
      information suppliers and third parties acting on behalf of OPay MFB to
      verify information about you which includes but is not limited to
      qualification, certification, employer background screening, employment
      verification, employment references, criminal records, driver’s license
      validation, passport validation, identity verification and any other
      personal information required to validate, verify and confirm your
      information. You understand and agree that your consent declaration will
      remain valid indefinitely for all existing and future personal and
      verification requests, screening, validation and confirmation of
      information regarding yourself.
    </p>
    <p class="text">
      <span class="bold">5. </span> You authorize us to use your information to
      create your unique account and wallet account on OPay MFB platform to
      receive the loan service and access other services.
    </p>
    <p class="text">
      <span class="bold">6. You must keep your account secure.</span>You are
      responsible for maintaining the confidentiality of your password and
      account. Furthermore, you are entirely responsible for any and all
      activities that occur through the use of your account or password. You
      agree to immediately notify us of any unauthorized use of your account or
      any other breach of security. An operation of your account by either
      yourself and/or any other individual shall be deemed to be an authorised
      transaction and you hereby indemnify us against and waive any claims
      relating to the unauthorized use of your account.
    </p>
    <p class="text">
      <span class="bold"
        >7. Our fee is payable on top of the amount you borrow.</span
      >Following the account registration process, you may be offered the
      opportunity to apply for loans in certain amounts. We reserve the right to
      decline the loan application for any reason. However, if we accept your
      application and grant you a loan we will charge a fee you must pay to us
      on top of paying back the borrowed amount (“Interest”). The Interest
      payable is stated together with the loan amount at the time you apply for
      each Loan. The loan shall be credited into your account wallet on the OPay
      MFB platform less deduction of the applicable Interest.
    </p>
    <p class="text">
      <span class="bold"
        >8. You must repay by the Due Date or rollover your Loan.</span
      >You must repay the Loan by the date specified when you take the Loan
      (“Due Date”). It is important that you repay the Loan and Interest by the
      Due Date. If you fail to do so, we will at our discretion rollover your
      Loan for a period of time determined by us ("Rollover Period") and charge
      you an additional fee ("Rollover Fee") in the amount of two percent (2%)
      per day. You must then repay the loaned amount, Interest and Rollover Fee
      by the end of the Rollover Period.
    </p>
    <p class="text">
      <span class="bold">9. If you fail to repay, you will be in default.</span
      >If you still have not repaid the Loan amount and fees, by the end of the
      Rollover Period, you will be in default. This default may be reported by
      us to credit reference bureaus duly licensed under the Credit Reporting
      Act 2017, within 28 (twenty-eight) days of your default and such report
      may affect your ability to borrow money in the future. You will become
      responsible for the reasonable costs we or our suppliers may incur in
      collecting the payment in accordance with applicable law. Overdue amounts
      will be rounded up to the nearest whole Nigerian Naira.
    </p>
    <p class="text">
      <span class="bold">10. Agent Loans and Interest.</span>Where a Loan is
      provided to you in your capacity as a registered Agent, you acknowledge
      and agree that that the Loan will be subject to Interest at a rate of
      zero-point four percent (0.4%) per day. Agent Loans require repayment
      within fourteen (14) days from the date the Loan is made to you, or such
      other date as may be agreed by us. Should you fail to repay the Loan on or
      before the due date, you will be liable to pay Interest at a rate of
      zero-point four percent (0.4%) per day until the Loan is repaid in full.
      The aforesaid Interest shall be calculated and compounded daily and shall
      be based upon the total outstanding amount which includes Interest already
      generated, Rollover Fees and penalties.
    </p>
    <p class="text">
      <span class="bold">11.You grant a mandate.</span>You expressly request,
      instruct and authorize us to debit (a) any of your bank accounts linked to
      your Bank Verification Number ("BVN"), and/or (b) OPay Accounts (including
      but not limited to OPay Wallet, OWealth and any other wallet,
      stored-value, card, savings or investment balances held on the OPay
      platform) you maintain with us, OPay Digital Services Limited, or our
      affiliates , for the amount of the Loan, Interest, Rollover Fee or any
      other applicable fees, as necessary for the payment due in respect of the
      Loan on the Due Date or, before or after the Rollover Period. All such
      debits from your account by us in accordance with this direct debit
      instruction issued and delivered to you by us shall be treated as though
      it was personally signed by you. You understand that the withdrawals
      hereby authorised will be processed by electronic funds transfer, and you
      also understand that details of each withdrawal will be printed on your
      bank statement. You expressly agree to pay any bank charges relating to
      this mandate.
    </p>
    <p class="text">
      <span class="bold"
        >12. You may also use your supported mobile money wallet, account or
        credit card</span
      >
      to pay for products and services offered by third party merchants on the
      OPay MFB platform, where applicable. Where applicable, these merchants
      sell their respective products subject to their own terms and conditions.
    </p>
    <p class="text">
      <span class="bold"
        >13. Where you decide to purchase products from third party
        Merchants</span
      >
      through our platform, you do so at your own risk and subject to the
      relevant Merchant’s terms and conditions. The products are not
      investigated, monitored, or checked for accuracy, reliability,
      appropriateness or completeness by OPay MFB. By permitting you to discover
      products via the Platform, OPay MFB does not imply approval or endorsement
      of such Products. You agree that OPay MFB is not responsible or liable for
      the Products you purchase from Merchants.
    </p>
    <p class="text">
      <span class="bold">14. We may contact you.</span>You expressly agree that,
      as part of the Services, you may, from time to time, receive
      communications from us via text message (SMS) or email, including our
      promotional newsletters or other information about the Services. You may
      stop receiving promotional messages by following the opt-out instructions
      in the message. Even if you choose to opt out of receiving promotional
      messages, you may not opt out of receiving service-related messages.
    </p>
    <p class="text">
      <span class="bold">15. You must respect our rights in the Platform.</span
      >We grant you a limited, non-transferable, personal right and license to
      use the Platform and any associated software application through which it
      may be provided. You may not copy, decompile, reverse engineer,
      disassemble, attempt to derive the source code of, modify, or create
      derivative works of the software (except as, and only to the extent that,
      any of the foregoing restrictions are prohibited by applicable law or to
      the limited extent permitted by the licensing terms governing use of any
      open-sourced components included within the software).
    </p>
    <p class="text">
      <span class="bold">16. We may discontinue the Services.</span> We may in
      our sole discretion and at any time terminate your access to the Platform
      or discontinue providing the Services or any part of the Services, with or
      without notice. You agree that we will not be responsible or liable to you
      or any third party for modifying or discontinuing the Services, or for
      terminating or suspending your access to the Platform.
    </p>
    <p class="text">
      <span class="bold">17. Legally Permitted Use of Platform.</span>We and our
      affiliated entities enforce a strict policy against money laundering,
      terrorism funding and conducting of business with entities/individuals
      situated in territories subject to trade sanction and/or are individually
      subject to such sanctions ("Policies"). In addition to other prohibitions
      as set forth in the Terms & Conditions, You are prohibited from using the
      Platform: (a) for any unlawful purpose; (b) to solicit others to perform
      or participate in any unlawful acts; (c) to violate any international,
      federal, provincial or state regulations, rules, laws, or local
      ordinances; (d) to infringe upon or violate our intellectual property
      rights or the intellectual property rights of others; (e) to harass,
      abuse, insult, harm, defame, slander, disparage, intimidate, or
      discriminate based on gender, sexual orientation, religion, ethnicity,
      race, age, national origin, or disability; (f) to submit false or
      misleading information; (g) to upload or transmit viruses or any other
      type of malicious code that will or may be used in any way that will
      affect the functionality or operation of the Service or of any related
      website, other websites, or the Internet; (h) to collect or track the
      personal information of others; (i) to spam, phish, pharm, pretext,
      spider, crawl, or scrape; (j) for any obscene or immoral purpose; or (k)
      to interfere with or circumvent the security features of the Services or
      any related website, other websites, or the Internet; or (l) to infringe
      and/or violate any laws or including but not limited to acts of fraud,
      money laundering, bribery, corruption and/or use any amounts loaned to you
      for illegal and/or illicit purposes. You furthermore agree that any
      amounts paid to us by you shall not be proceeds from illegal activities.
      Should it be proven and/or suspected by us that the Platform is being used
      for illegal and/or illicit purposes and/or violate our Policies we reserve
      the right to immediately terminate the Services available to you and
      furthermore reserve our rights to report your conduct to the relevant
      legal authorities for investigation and possible prosecution.
    </p>
    <p class="text">
      <span class="bold"
        >18. The Services are provided without any warranties or
        guarantees.</span
      >THE SERVICES ARE PROVIDED "AS IS" WITHOUT WARRANTY OF ANY KIND. WE [AND
      OUR SUPPLIERS] DISCLAIM ALL WARRANTIES WITH REGARD TO THE SERVICES,
      INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
      PARTICULAR PURPOSE, TITLE, AND NON-INFRINGEMENT. IF YOU ARE DISSATISFIED
      WITH ANY PORTION OF THE PLATFORM, OR WITH THESE TERMS, YOUR SOLE AND
      EXCLUSIVE REMEDY IS TO DISCONTINUE USING THE SERVICES.
    </p>
    <p class="text">
      <span class="bold"
        >19.We are not liable for any damages you may incur.</span
      >IN NO EVENT WILL WE OR OUR SUPPLIERS BE LIABLE FOR ANY DIRECT, INDIRECT,
      PUNITIVE, INCIDENTAL, SPECIAL, CONSEQUENTIAL DAMAGES, OR ANY DAMAGES
      WHATSOEVER INCLUDING, WITHOUT LIMITATION, DAMAGES FOR LOSS OF USE, DATA,
      OR PROFITS, ARISING OUT OF OR IN ANY WAY CONNECTED WITH THE USE OR
      PERFORMANCE OF THE SERVICES, WITH THE DELAY OR INABILITY TO USE THE
      SERVICES, THE PROVISION OF OR FAILURE TO PROVIDE THE SERVICES, OR FOR ANY
      LOAN OBTAINED THROUGH THE PLATFORM, OR OTHERWISE ARISING OUT OF THE USE OF
      THE PLATFORM, WHETHER BASED ON CONTRACT, TORT, NEGLIGENCE, STRICT
      LIABILITY, OR OTHERWISE, EVEN IF APPS AND GAMES AS OR ANY OF ITS SUPPLIERS
      HAVE BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.
    </p>
    <p class="text">
      <span class="bold">20.</span>This contract is subject to, and shall be
      governed by, and construed in accordance with the laws of Nigeria, without
      reference to the principles of conflict of laws thereof. Any matters
      arising concerning the interpretation, validity or implementation of this
      Agreement not solved by mutual agreement between the Parties shall be
      submitted to arbitration in the English language before a sole arbitrator
      to take place in Lagos, Nigeria as the seat of the arbitration. The
      arbitration shall be conducted pursuant to the Rules of Arbitration of the
      Chartered Institute of Arbitrators of the United Kingdom. The arbitral
      decision shall be final and binding on the Parties and may be made an
      order of court. The Parties unconditionally consent and submit to the
      jurisdiction of the High Court of Lagos, Nigeria for such purpose. Nothing
      in this Agreement will be deemed as preventing OPay MFB from seeking
      injunctive relief (or any other provisional remedy) from any court having
      jurisdiction over the Parties and the subject matter of the dispute as is
      necessary to protect OPay MFB’s name, proprietary information, trade
      secrets, know-how, or any other intellectual property rights.
    </p>
    <p class="text">
      <span class="bold">21.</span>No alteration, variation or agreed
      cancellation of this agreement, and this paragraph, shall be of any effect
      unless directed so by us. The updated Terms shall become effective
      immediately upon posting. Your continued use of our services after any
      such change constitutes your acceptance of the updated Terms. We may
      notify you of significant changes through in-app notification, email, or
      other reasonable means.
    </p>
    <p class="text">
      <span class="bold">22. </span>This Agreement constitutes the whole
      agreement between the Parties in regard to the subject matter thereof and
      no warranties or representations of any nature whatsoever other than set
      out in this agreement have been given by any of the parties.
    </p>
    <p class="text">
      <span class="bold">23.</span>No relaxation or indulgence which any party
      may show to any other party to this Agreement shall in any way prejudice
      or be deemed to be a waiver of its rights hereunder.
    </p>
    <p class="text">
      <span class="bold">24.</span>Each and every provision of this Agreement
      (excluding only those provisions which are essential at law for a valid
      and binding Agreement to be constituted) shall be deemed to be separate
      and severable from the remaining provisions of this Agreement. If any of
      the provisions of this Agreement (excluding only those provisions which
      are essential at law for a valid and binding Agreement to be constituted)
      is found by any court of competent jurisdiction to be invalid and/or
      unenforceable then, notwithstanding such invalidity and/or
      unenforceability, the remaining provisions of this Agreement shall be and
      remain of full force and effect.
    </p>
    <p class="text">
      <span class="bold">25. </span>Any substantive provision appearing in, or
      as a part of, any interpretative provision of this agreement shall have
      effect in accordance with its tenor, notwithstanding the context in which
      it appears.
    </p>
    <p class="text">
      <span class="bold">26. </span
      ><span class="bold">Assignment on Merger or Acquisition.</span> In the
      event that OPay MFB undergoes a merger, acquisition, corporate
      reorganization, or sale of all or substantially all of its assets or
      business, all rights and obligations arising under these Terms and
      Conditions shall automatically be assigned to, assumed by, and continue to
      be enforceable against and by the successor or acquiring entity, without
      the need for further consent from you. Such successor or acquiring entity
      shall be deemed substituted for OPay MFB for all purposes under these
      Terms and Conditions.
    </p>
    <p class="text">
      <span class="bold">27. </span>We may modify these Terms. These Terms may
      be modified without notice at any time in the future. Changes will be
      posted at (https://www.opaymfb.com/#/terms) or its successor URL. It is
      your responsibility to remain informed of any changes as you are bound by
      the latest version of the Terms.
    </p>
  </div>
</template>
<script>
export default {
  name: "privacyCom",
  props: {
    title: {
      type: String,
      default: "TERMS OF SERVICE",
    },
  },
  data() {
    return {};
  },
  methods: {},
};
</script>
